import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Global smart prisregel for {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Master-smart prisregel for {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.menu]: 'Smart prisregel for menuen {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.category]: 'Smart prisregel for kategorien {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.product]: 'Smart prisregel for produktet {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Smart prisregel for modifikatorgruppen {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Smart prisregel for modifikatoren {{name}}',
  },
  labels: {
    new: 'Ny',
    base_price: 'Grundpris for {{name}}: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Menu',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Kategori',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Produkt',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Modifikatorgruppe',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modifikator',
      placeholder: 'Vælg {{resource}}',
    },
    order_methods: {
      label: 'Bestillingsmetoder',
      placeholder: 'Vælg de bestillingsmetoder, reglen gælder for',
      options: {
        [ORDER_METHODS.pickup]: 'Afhentning',
        [ORDER_METHODS.delivery]: 'Levering',
        [ORDER_METHODS.on_site]: 'Bordbestilling',
      },
    },
    modifier_type: {
      label: 'Type af prisjustering',
      placeholder: 'Vælg type af prisjustering',
      disabled_tooltip:
        'Absolut er ikke tilgængelig for regler, der gælder hele menuen, da den ville overskrive alle varers priser.',
      tooltip: {
        title: 'Justeringstypen bestemmer, hvordan priserne ændres',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]:
            'Absolut: overskriver ressourcens pris med den angivne justeringsværdi',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Procent: lægger den angivne procentværdi til ressourcens grundpris eller trækker den fra, afhængigt af værdiens fortegn',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Fast beløb: lægger det angivne faste beløb til grundprisen eller trækker det fra, afhængigt af værdiens fortegn',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absolut',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Procent',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Fast beløb',
      },
    },
    modifier_value: {
      label: 'Værdi for prisjustering',
    },
    round: {
      label: 'Afrund den resulterende pris',
      tooltip:
        'Runder den resulterende pris op med 10 (f.eks. bliver 14,91, 14,93 og 14,99 til 15,00). Mest nyttigt for procentregler',
    },
    is_visible: {
      label: 'Vis kunden som et tilbud',
    },
    name: {
      label: 'Navn',
      placeholder: 'Indtast kundevenligt navn',
      default: '{{value}} rabat på {{resource}}',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne blev gemt',
  },
};
